<template>
  <div id="userOptions">
    <button
      v-if="$store.getters.hasUmbracoConnection && $store.getters.hasPrivilege"
      @click="umbracoSync"
      class="lg-btn"
    >Perform sync</button>
    <button v-if="$store.getters.hasPrivilege" @click="signOut" class="lg-btn">Sign out</button>
    <button
      v-if="!$store.getters.hasPrivilege"
      @click="toggleSignIn = !toggleSignIn, error = false"
      class="lg-btn"
    >Sign in</button>
    <div class="signIn" v-if="toggleSignIn">
      <div class="input-group">
        <input type="text" placeholder="Username" v-model="user.Username" />
        <fa icon="user" />
      </div>
      <div class="input-group">
        <input type="password" placeholder="Password" v-model="user.Password" />
        <fa icon="key" />
      </div>
      <button
        v-if="!$store.getters.hasUmbracoConnection && !$store.getters.hasPrivilege"
        @click="firebaseSignIn"
        class="lg-btn"
      >Sign in</button>
      <button
        v-else-if="$store.getters.hasUmbracoConnection && !$store.getters.hasPrivilege"
        @click="umbracoSignIn"
        class="lg-btn"
      >Sign in to Umbraco</button>
      <p v-show="error">Invalid user data, please try again.</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import sha256 from "crypto-js/sha256";
import { db, auth } from "@/firebase.js";
import dataService from "@/DataSyncService";
const path = "/UserLogins/";
const lsKey = "Opskrifter_Token";
export default {
  data() {
    return {
      user: {
        Username: "",
        Password: ""
      },
      toggleSignIn: false,
      error: false
    };
  },
  methods: {
    umbracoSignIn() {
      this.error = false;
      const url = `${process.env.VUE_APP_BASE_API_URL}/AuthApi/Login`;
      axios
        .post(url, JSON.stringify(this.user))
        .then(res => {
          if (res.data != 0) {
            this.userId = res.data;
            const username = sha256(
              process.env.VUE_APP_SHA_KEY + this.user.Username.trim()
            ).toString();
            const token = sha256(
              process.env.VUE_APP_SHA_KEY + this.user.Password
            ).toString();
            const user = {
              umbracoId: this.userId,
              password: token
            };
            auth.signInAnonymously().then(() => {
              db.doc(path + username).set(user);
              localStorage.setItem(lsKey, username);
              this.$store.dispatch("checkUserAccess");
              this.toggleSignIn = false;
            })
          } else {
            this.error = true;
          }
        })
        .catch(err => console.log(err));
    },
    async firebaseSignIn() {
      this.error = false;
      const username = sha256(
        process.env.VUE_APP_SHA_KEY + this.user.Username.trim()
      ).toString();
      const password = sha256(
        process.env.VUE_APP_SHA_KEY + this.user.Password
      ).toString();
      const userId = await db
        .collection("UserLogins")
        .doc(username)
        .get();
      const success = userId.data().password == password;
      if (success) {
        localStorage.setItem(lsKey, username);
        this.toggleSignIn = false;
        this.$store.dispatch("checkUserAccess");
      } else {
        this.error = true;
      }
    },
    async signOut() {
      // Clear localstorage
      localStorage.removeItem(lsKey);
      // Commit checkUserAccess from AuthStore
      this.$store.dispatch("checkUserAccess");
    },
    async umbracoSync() {
      this.$store.commit("setLoading", true);
      await dataService.performSync().then(async () => {
        await this.$store.dispatch("init").then(() => {
          this.$store.commit("setLoading", false);
        });
      });
    }
  }
};
</script>

<style lang="scss">
</style>